import React, { Component } from 'react'
import SVG from 'react-inlinesvg'
import arrow from '@icons/arrow-right-white'
import { defaultSubjectPath } from '@app/components/ui/buttons/PlatformLink'

class BonusTask extends Component {
  render() {
    if (window.COUNTRY !== 'IN' && !window.COUNTRY !== 'RU') { return null }

    let params = {redirect: 'recommended_card'}

    if (window.COUNTRY === 'IN') {
      params = Object.assign(params, {
        utm_source: 'bricsmath',
        utm_medium: 'add_task',
        utm_campaign: 'eternal_link'
      })
    }

    return (
      <div className="bonus-task">
        <div className="bonus-task__row">
          <div className="bonus-task__icon" />
          <p className="bonus-task__text">
            { I18n.t("students.bonus_task.text") }
          </p>
        </div>
        <div className="bonus-task__row">
          <a
            href={ defaultSubjectPath() }
            target="_blank"
            className="btn btn--icon-right bonus-task__link">

            { I18n.t("js.students_table.solve") }
            <SVG src={arrow} />
          </a>
        </div>
      </div>
    )
  }
}

export default BonusTask
